import styled from 'styled-components';
import { IShevronStyledProps } from './select-shevron-action.types';

export const ShevronStyled = styled.div<IShevronStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${({ $isOpen }) => $isOpen ? 180 : 0}deg);
`;
